import { Button, ButtonProps } from "bambu/lib/elements/button";
import * as React from "react";
import { Link } from "react-router-dom";

export interface HeaderButton extends ButtonProps {
  name?: string;
  icon?: any | string;
  href?: string;
  onClick?: Function | any;
  disabled?: boolean;
  text?: string;
  width?: number;
  fontSize?: number;
  height?: number | string;
  transform?: string;
  color?: string;
  border?: string;
}

export default class ElementUtil {
  public static getUpdateButton(href: string, disabled: boolean) {
    return ElementUtil.getButton({
      href,
      disabled,
      name: "update",
      icon: "icon_update",
    });
  }

  public static getDeleteButton(onClick: Function, disabled: boolean, props?: HeaderButton) {
    return ElementUtil.getButton({
      onClick,
      disabled,
      name: "delete",
      icon: "icon_delete",
      ...props,
    });
  }

  public static getDetailsButton(onClick: Function, disabled: boolean, props?: HeaderButton) {
    return ElementUtil.getButton({
      onClick,
      disabled,
      text: "details",
      name: "details",
      ...props,
    });
  }

  public static getManageButton(name: string, href?: string) {
    return ElementUtil.getButton({
      name: "manage",
      icon: "list-ul",
      href: href ? href : `/${name}/manage`,
    });
  }

  public static getPromotionOrderButton(name: string) {
    return ElementUtil.getButton({
      name: "manage",
      icon: "icon_change_order",
      href: `/${name}/manage`,
      width: 35,
    });
  }

  public static getButton(menu: HeaderButton) {
    if (typeof menu.icon === "string" && (menu.icon.startsWith("icon_") || menu.icon.startsWith("v2/icon_"))) {
      const ICON = <img style={{ width: menu.width ? menu.width : 40 }} src={`vendor/images/icons/svg/${menu.icon}.svg`} />;

      const BUTTON = (
        <Button
          tagName="button"
          style={{
            backgroundColor: "transparent",
            border: menu.border || "none",
            width: menu.width || 35,
            marginLeft: 5,
            display: "flex",
            alignItems: "center",
            padding: 0,
            transform: menu.transform,
          }}
          key={menu.name}
          onClick={menu.onClick}
          disabled={menu.disabled}
        >
          {ICON}
        </Button>
      );

      if (menu.href && !menu.disabled) {
        return (
          <Link key={menu.name} to={menu.href} style={{ alignItems: "center", display: "flex" }}>
            {BUTTON}
          </Link>
        );
      }
      return BUTTON;
    }
    return ElementUtil.generateButton(menu);
  }

  public static generateButton(menu: HeaderButton) {
    let iconProps: any;
    if (menu.icon) {
      if (typeof menu.icon === "string") {
        iconProps = { name: menu.icon, size: "lg" };
      } else {
        iconProps = { size: "lg", ...menu.icon };
      }
    }
    const BUTTON = (
      <Button
        tagName="button"
        style={{
          backgroundColor: "transparent",
          border: menu.border || "none",
          height: menu.height || 52,
          fontSize: menu.fontSize || 20,
          transform: menu.transform,
          color: menu.color || "white",
        }}
        key={menu.name}
        onClick={menu.onClick}
        disabled={menu.disabled}
        icon={iconProps}
      >
        {menu.text}
      </Button>
    );

    if (menu.href && !menu.disabled) {
      return (
        <Link key={menu.name} to={menu.href} style={{ color: "white" }}>
          {BUTTON}
        </Link>
      );
    }
    return BUTTON;
  }
}
